import { Loader } from '@googlemaps/js-api-loader';
import {
  getSearchUrlFromGooglePlace,
  getPlaceSearchUrl,
  parseGooglePlace,
} from '@mashvisor/design-system/lib/search-url';

const loader = new Loader({
  apiKey: 'AIzaSyDt9U0GJGEi9MI5bpcRuWJIeN04J58CHsM',
  version: 'weekly',
});

export const loadPlaces = () => {
  return loader.importLibrary('places');
};

export const openSearchPageByPlace = googlePlace => {
  const searchUrl =
    (googlePlace &&
      getSearchUrlFromGooglePlace(googlePlace, {
        extraHashParams: { src: 'search_input' },
      })) ||
    '/explore/search';
  window.location.href = searchUrl;
};
export { parseGooglePlace, getPlaceSearchUrl };
